export const SET_STATE_APP = "@@app/SET_STATE_APP";